document.addEventListener("DOMContentLoaded", function () {
  const collectionLink = document.getElementById("collection");
  const overlay = document.getElementById("overlay");
  const closeOverlay = document.getElementById("closeOverlay");
  const header = document.getElementById("fixedHeader");
  const mainHeader = document.getElementById("mainHeader");
  const mobileHeader = document.getElementById("Mheader");
  const openSizeChartBtn = document.getElementById("openSizeChart");
  const closeSizeChartBtn = document.getElementById("closeSizeChart");
  const sizeChartOverlay = document.getElementById("size-chart-overlay");

  // Ensure elements exist before adding event listeners
  if (collectionLink && overlay) {
    collectionLink.addEventListener("click", function (event) {
      event.preventDefault();
      overlay.style.display = "flex"; // Show overlay
    });
  }

  if (closeOverlay && overlay) {
    closeOverlay.addEventListener("click", function () {
      overlay.style.display = "none"; // Hide overlay
    });
  }

  // Add scroll event listener to change header style
  window.addEventListener("scroll", function () {
    if (mainHeader) {
      mainHeader.classList.toggle("scrolled", window.scrollY > 40);
    }
    if (mobileHeader) {
      mobileHeader.classList.toggle("mscrolled", window.scrollY > 40);
    }
    if (header) {
      header.classList.toggle("scrolled", window.scrollY > 40);
    }
  });

  // Ensure size chart elements exist before adding event listeners
  if (openSizeChartBtn && closeSizeChartBtn && sizeChartOverlay) {
    openSizeChartBtn.addEventListener("click", function () {
      sizeChartOverlay.classList.add("active"); // Show size chart overlay
    });

    closeSizeChartBtn.addEventListener("click", function () {
      sizeChartOverlay.classList.remove("active"); // Hide size chart overlay
    });
  }
});

document.addEventListener("DOMContentLoaded", function () {
  setTimeout(() => {
    const feedButton = document.querySelector(
      'a[href="https://elfsight.com/instagram-feed-instashow/?utm_source=websites&utm_medium=clients&utm_content=instashow&utm_term=demo.technophilic.co&utm_campaign=free-widget"]'
    );
    if (feedButton) {
      feedButton.style.display = "none";
    } else {
      // console.log('Feed button not found');
    }
  }, 6000);
});

// dropdown
document.addEventListener("DOMContentLoaded", () => {
  const accordionItems = document.querySelectorAll(".accordion-item");

  accordionItems.forEach((item) => {
    item.addEventListener("mouseenter", () => {
      accordionItems.forEach((i) => {
        const content = i.querySelector(".accordion-content");
        const title = i.querySelector(".accordion-title");
        if (content && title) {
          content.style.display = "none";
          title.classList.remove("active");
        }
      });

      const accordionContent = item.querySelector(".accordion-content");
      const accordionTitle = item.querySelector(".accordion-title");
      if (accordionContent && accordionTitle) {
        accordionContent.style.display = "block";
        accordionTitle.classList.add("active");
      }
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const menuToggle = document.getElementById("menu-toggle");
  const mobileOverlay = document.getElementById("mobileOverlay");
  const closeOverlay = document.getElementById("McloseOverlay");

  if (menuToggle && mobileOverlay) {
    menuToggle.addEventListener("click", function () {
      mobileOverlay.style.display = "flex";
      document.body.classList.add("no-scroll");
    });
  }

  if (closeOverlay && mobileOverlay) {
    closeOverlay.addEventListener("click", function () {
      mobileOverlay.style.display = "none";
      document.body.classList.remove("no-scroll");
    });
  }

  const menuItems = document.querySelectorAll(".menu-item");

  menuItems.forEach((item) => {
    item.addEventListener("click", function () {
      const submenu = item.nextElementSibling;
      if (submenu && submenu.classList.contains("submenu")) {
        const parent = item.parentElement.parentElement;
        const otherSubmenus = parent.querySelectorAll(".submenu");
        otherSubmenus.forEach((other) => {
          if (other !== submenu) {
            other.style.display = "none";
            const otherTrigger = other.previousElementSibling;
            const otherChevron = otherTrigger
              ? otherTrigger.querySelector(".chevron")
              : null;
            if (otherChevron) {
              otherChevron.classList.remove("rotate");
            }
          }
        });

        if (submenu.style.display === "block") {
          submenu.style.display = "none";
          const chevron = item.querySelector(".chevron");
          if (chevron) {
            chevron.classList.remove("rotate");
          }
        } else {
          submenu.style.display = "block";
          const chevron = item.querySelector(".chevron");
          if (chevron) {
            chevron.classList.add("rotate");
          }
        }
      }
    });
  });
});

function closeMenu() {
  const mobileOverlay = document.getElementById("mobileOverlay");
  if (mobileOverlay) mobileOverlay.style.display = "none";
}

function openMenu() {
  const mobileOverlay = document.getElementById("mobileOverlay");
  if (mobileOverlay) mobileOverlay.style.display = "block";
}

// search overlay
document.addEventListener("DOMContentLoaded", function () {
  const searchToggle = document.getElementById("search-toggle");
  const searchTogglemobile = document.getElementById("search-toggle-mobile");
  const searchOverlay = document.getElementById("search-Overlay");
  const closeSOverlay = document.getElementById("closeSOverlay");

  if (searchToggle && searchOverlay) {
    searchToggle.addEventListener("click", function () {
      searchOverlay.style.display = "flex";
    });
  }

  if (searchTogglemobile && searchOverlay) {
    searchTogglemobile.addEventListener("click", function () {
      searchOverlay.style.display = "flex";
    });
  }

  if (closeSOverlay && searchOverlay) {
    closeSOverlay.addEventListener("click", function () {
      searchOverlay.style.display = "none";
    });
  }
});

// banner Slider Initialization -->

document.addEventListener("DOMContentLoaded", function () {
  $(".hero-banner__slider").slick({
    slidesToShow: 1,

    autoplay: true,
    autoplaySpeed: 5000,
    // arrows: true,
    fade: true,
    dots: false,
    prevArrow: $(".prev-arr"),
    nextArrow: $(".next-arr"),
  });
});

// Shop Slider Initialization -->
document.addEventListener("DOMContentLoaded", function () {
  const maxDots = 5; // Number of dots visible at a time

  $(".shop-categories__slider").on(
    "init reInit afterChange",
    function (event, slick, currentSlide, nextSlide) {
      const totalSlides = slick.slideCount;
      let start = 0;
      let end = maxDots;

      if (currentSlide >= 3) {
        start = currentSlide - 2;
        end = start + maxDots;
        if (end > totalSlides) {
          end = totalSlides;
          start = end - maxDots;
        }
      }

      $(".slick-dots li").each(function (index) {
        if (index >= start && index < end) {
          $(this).show();
        } else {
          $(this).hide();
        }
      });
    }
  );

  $(".shop-categories__slider").slick({
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    variableWidth: true,
    prevArrow: $(".prev-arrow"),
    nextArrow: $(".next-arrow"),
    customPaging: function (slider, i) {
      return '<button class="slick-dot">' + (i + 1) + "</button>";
    },
    responsive: [
      {
        breakpoint: 1024, // Large screen breakpoint
        settings: {
          slidesToShow: 2.4,
        },
      },
      {
        breakpoint: 768, // Tablet screen breakpoint
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480, // Mobile screen breakpoint
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });
});

// testimonial
function initSlick() {
  if ($(".testimonial-slider").hasClass("slick-initialized")) {
    $(".testimonial-slider").slick("unslick"); // Remove existing Slick instance
  }

  $(".testimonial-slider").slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToScroll: 1,
    slidesToShow: 3,
    centerMode: true,
    centerPadding: "50px",
    prevArrow: $(".prev"),
    nextArrow: $(".next"),
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          centerPadding: "50px",
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          centerPadding: "0",
        },
      },
    ],
  });
}

$(document).ready(initSlick);

document.addEventListener("DOMContentLoaded", function () {
  const stars = document.querySelectorAll(".star");

  stars.forEach((star, index) => {
    star.addEventListener("click", () => {
      // Remove the fill from all stars
      stars.forEach((s) =>
        s.querySelector("path").setAttribute("fill", "none")
      );

      // Fill all stars up to the clicked one
      for (let i = 0; i <= index; i++) {
        stars[i].querySelector("path").setAttribute("fill", "#FFF");
      }
    });
  });

  // Dynamic rating summary stars for the review section
  const ratingSummaryStars = document.querySelectorAll(
    ".reviews-section__reviews-rating-summary .stars"
  );

  ratingSummaryStars.forEach((summaryStar) => {
    const rating = parseInt(summaryStar.getAttribute("data-rating"));
    let starHTML = "";
    for (let i = 1; i <= 5; i++) {
      if (i <= rating) {
        starHTML += "&#9733;"; // Filled star
      } else {
        starHTML += "&#9734;"; // Unfilled star
      }
    }
    summaryStar.innerHTML = starHTML;
  });

  // Details
  const details = document.querySelectorAll("details");

  details.forEach((detail) => {
    detail.addEventListener("toggle", function () {
      // Close all other details except the one clicked
      if (this.open) {
        details.forEach((otherDetail) => {
          if (otherDetail !== this) {
            otherDetail.removeAttribute("open");
          }
        });
      }
    });
  });
});

jQuery(function ($) {
  $(".variations_form").on("show_variation", function (event, variation) {
    var template = wp.template("variation-template");
    $(".woocommerce-Price-amount-single-custom").html(
      template({ variation: variation })
    );
    $(".single_variation_wrap>.single_variation").empty(); // Clear the details on reset
  });

  $(".variations_form").on("reset_data", function () {
    //$('.woocommerce-Price-amount-single-custom').empty(); // Clear the details on reset
  });
});

// Product review star
document.addEventListener("DOMContentLoaded", function () {
  const stars = document.querySelectorAll(".star-label");
  const hiddenInput = document.getElementById("selected-rating");

  stars.forEach((star) => {
    star.addEventListener("click", function () {
      let rating = this.getAttribute("data-rating");
      hiddenInput.value = rating;

      // Reset all stars
      stars.forEach((s) =>
        s.querySelector("svg").setAttribute("fill", "#ccc")
      );

      // Highlight selected and previous stars
      for (let i = 0; i < rating; i++) {
        stars[i].querySelector("svg").setAttribute("fill", "#f5c518");
      }
    });
  });
});

// Infinite scroll
document.addEventListener("DOMContentLoaded", function () {
  const productsList = document.getElementById("products-list");
  if (!productsList) return;

  let page = 2; // Start from page 2 after the initial load
  let loading = false;
  let productsFound = true;
  const loadingIndicator = document.getElementById("loading");
  let lastScrollY = window.scrollY; // Track last scroll position

  const loadMoreProducts = () => {
    if (loading || !productsFound) return;
    loading = true;

    if (loadingIndicator) loadingIndicator.style.display = "block";

    setTimeout(() => {
      const url = new URL(window.location.href);
      url.searchParams.set("paged", page);

      fetch(url.toString())
        .then((response) => response.text())
        .then((html) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, "text/html");
          const newProducts = Array.from(
            doc.querySelectorAll(".collection-list__product")
          );

          if (newProducts.length > 0) {
            newProducts.forEach((product) => productsList.appendChild(product));
            page++;
          } else {
            productsFound = false;
            if (loadingIndicator) {
              loadingIndicator.innerHTML = "<p>No more products to load</p>";
              loadingIndicator.style.display = "block";
            }
          }
        })
        .catch((error) => console.error("Error loading products:", error))
        .finally(() => {
          if (productsFound && loadingIndicator)
            loadingIndicator.style.display = "none";
          loading = false;
        });
    }, 500); // half-second delay before fetching
  };

  const scrollHandler = () => {
    let scrollDifference = window.scrollY - lastScrollY;

    if (scrollDifference >= 400 && productsFound) {
      loadMoreProducts();
      lastScrollY = window.scrollY; // Update last scroll position
    }
  };

  window.addEventListener("scroll", scrollHandler);
  loadMoreProducts(); // Initial load

  document.body.addEventListener("click", function (event) {
    const colorSwatch = event.target.closest(".variable-item-span");
    if (!colorSwatch) return;

    const imageUrl = colorSwatch.getAttribute("data-image");
    const productId = colorSwatch.getAttribute("data-product-id");
    const newPrice = colorSwatch.getAttribute("data-price");

    const formattedPrice = `${currencySymbol}${parseFloat(newPrice).toFixed(
      2
    )}`;

    // Update product image
    const productImage = document.getElementById("product-image-" + productId);
    if (productImage) {
      productImage.src = imageUrl;
    }

    // Update price
    const priceElement = document.getElementById("product-price-" + productId);
    if (priceElement) {
      priceElement.innerHTML = formattedPrice;
    }
  });
});

// for variation product buy now button javascript

// Display Popup when a product is added to cart

document.addEventListener("DOMContentLoaded", function () {
  const addToCartButton = document.querySelector(".single_add_to_cart_button");

  if (addToCartButton) {
    addToCartButton.addEventListener("click", function () {
      const productTitleElement = document.querySelector(
        ".product-banner__desc"
      );
      if (productTitleElement) {
        localStorage.setItem(
          "addedProduct",
          productTitleElement.textContent.trim()
        );
      }
    });
  }

  if (window.location.pathname.endsWith("/cart/")) {
    const addedProduct = localStorage.getItem("addedProduct");

    if (addedProduct) {
      showToast(addedProduct);
      localStorage.removeItem("addedProduct");
    }
  }
});

// Testimonials expand collapse

document.addEventListener("DOMContentLoaded", function () {
  document
    .querySelectorAll(".reviews-section__comments-item")
    .forEach((item) => {
      const content = item.querySelector(
        ".reviews-section__comments-item--content"
      );
      const button = document.createElement("button");
      button.classList.add("expand-btn");
      button.textContent = "Read More";

      if (content.scrollHeight > content.clientHeight) {
        content.classList.add("content-expandable");
        item.appendChild(button);
        button.style.display = "block";
      }

      button.addEventListener("click", function () {
        if (content.classList.contains("content-expandable")) {
          content.classList.remove("content-expandable");
          content.classList.add("content-collapsible");

          button.classList.remove("expand-btn");
          button.classList.add("collapse-btn");
          button.textContent = "Close";
        } else {
          content.classList.remove("content-collapsible");
          content.classList.add("content-expandable");

          button.classList.remove("collapse-btn");
          button.classList.add("expand-btn");
          button.textContent = "Expand";
        }
      });
    });
});

// Keep the custom Slick presentation in sync with WooCommerce's native
// variation gallery payload. WooCommerce remains responsible for resolving the
// selected attributes and the swatches plugin remains responsible for ARIA.
jQuery(function ($) {
  const $form = $(".variations_form").first();
  const $main = $(".product-banner__slides").first();
  if (!$form.length || !$main.length || typeof $.fn.slick !== "function") return;

  let defaultImages = [];
  let currentSignature = "";
  let renderToken = 0;
  try {
    defaultImages = JSON.parse($main.attr("data-default-images") || "[]");
  } catch (error) {
    defaultImages = [];
  }

  function imageSignature(images) {
    return images.map((image) => Number(image.id) || image.full).join("|");
  }

  function createImage(image, isThumbnail, index) {
    const img = document.createElement("img");
    img.src = isThumbnail ? image.thumb || image.full : image.full;
    img.alt = image.alt || "";
    if (!isThumbnail) {
      if (image.srcset) img.srcset = image.srcset;
      if (image.sizes) img.sizes = image.sizes;
      if (image.width) img.width = image.width;
      if (image.height) img.height = image.height;
      if (index > 0) img.loading = "lazy";
    }
    return img;
  }

  function createSlides(images, isThumbnail) {
    return images.map((image, index) => {
      const slide = document.createElement("div");
      slide.className = "product-banner__slide";
      slide.dataset.imageId = image.id || "";
      slide.appendChild(createImage(image, isThumbnail, index));
      return slide;
    });
  }

  function replaceContents($slider, slides) {
    if ($slider.hasClass("slick-initialized")) $slider.slick("unslick");
    $slider.empty().append(slides);
  }

  function initMainSlider() {
    $main.slick({
      dots: false,
      infinite: $main.children().length > 1,
      speed: 250,
      slidesToShow: 1,
      centerMode: false,
      variableWidth: false,
      fade: true,
      arrows: false,
      adaptiveHeight: false,
    });
  }

  function initThumbnailSlider($slider) {
    if (!$slider.length) return;
    $slider.slick({
      slidesToShow: Math.min(4, Math.max(1, $slider.children().length)),
      slidesToScroll: 1,
      dots: false,
      focusOnSelect: true,
      arrows: false,
      infinite: false,
      swipeToSlide: true,
    });
  }

  function bindThumbnailClicks() {
    $(".slider-nav, .slider-nav-mobile")
      .off("click.ccVariationGallery")
      .on("click.ccVariationGallery", ".product-banner__slide", function () {
        const index = Number($(this).attr("data-slick-index"));
        if (Number.isInteger(index) && $main.hasClass("slick-initialized")) {
          $main.slick("slickGoTo", index);
        }
      });
  }

  function initializeGallery() {
    const $desktopNav = $(".slider-nav:not(.slider-nav-mobile)");
    const $mobileNav = $(".slider-nav-mobile");
    replaceContents($main, $main.children().toArray());
    replaceContents($desktopNav, $desktopNav.children().toArray());
    replaceContents($mobileNav, $mobileNav.children().toArray());
    initMainSlider();
    initThumbnailSlider($desktopNav);
    initThumbnailSlider($mobileNav);
    bindThumbnailClicks();
  }

  function showImages(images) {
    if (!Array.isArray(images) || !images.length) images = defaultImages;
    if (!images.length) return;
    const signature = imageSignature(images);
    if (signature === currentSignature) return;
    currentSignature = signature;
    const token = ++renderToken;
    $main.addClass("is-loading").attr("aria-busy", "true");

    const firstImage = new Image();
    firstImage.onload = firstImage.onerror = function () {
      if (token !== renderToken) return;
      replaceContents($main, createSlides(images, false));
      const $desktopNav = $(".slider-nav:not(.slider-nav-mobile)");
      const $mobileNav = $(".slider-nav-mobile");
      replaceContents($desktopNav, createSlides(images, true));
      replaceContents($mobileNav, createSlides(images, true));
      initMainSlider();
      initThumbnailSlider($desktopNav);
      initThumbnailSlider($mobileNav);
      bindThumbnailClicks();
      $(".slider-nav, .slider-nav-mobile").each(function () {
        $(this).find('.product-banner__slide[data-slick-index="0"]').addClass("is-active");
      });
      $main.removeClass("is-loading").attr("aria-busy", "false");
    };
    firstImage.src = images[0].full;
  }

  initializeGallery();
  currentSignature = imageSignature(
    $main.find(".product-banner__slide").map(function () {
      return { id: $(this).attr("data-image-id") || "" };
    }).get()
  );
  bindThumbnailClicks();

  $main.on("afterChange.ccVariationGallery", function (event, slick, currentSlide) {
    $(".slider-nav, .slider-nav-mobile").each(function () {
      $(this).find(".product-banner__slide").removeClass("is-active");
      $(this)
        .find('.product-banner__slide[data-slick-index="' + currentSlide + '"]')
        .addClass("is-active");
    });
  });

  $form.on("show_variation.ccVariationGallery", function (event, variation) {
    showImages(variation.cc_gallery_images || []);
  });
  $form.on("reset_data.ccVariationGallery hide_variation.ccVariationGallery", function () {
    showImages(defaultImages);
  });
});
// add to wishlist click event
document.addEventListener("DOMContentLoaded", function () {
  document.body.addEventListener("click", function (event) {
    // Check if the clicked element is exactly the wishlist text
    const wishlistText = event.target.closest(".wishlist-text");
    if (!wishlistText) return;

    // Find the wishlist container div
    const wishlistDiv = wishlistText.closest(".product-banner__wishlist");
    if (!wishlistDiv) return;

    // Find the actual wishlist button inside the div
    const wishlistButton = wishlistDiv.querySelector("button, a");
    if (wishlistButton) {
      wishlistButton.click(); // Trigger the wishlist button
    }
  });
});

// Blog infinite scroll pagination
document.addEventListener("DOMContentLoaded", function () {
  const blogPostsContainer = document.getElementById("blog-posts-container");
  const loadingIndicator = document.getElementById("infinite-scroll-loader");

  if (!blogPostsContainer) return; // Exit if not on blog page

  let isLoading = false;
  let currentPage = parseInt(ajaxCNC.current_page) || 1;
  const maxPages = parseInt(ajaxCNC.max_pages) || 1;
  let allPostsLoaded = false;

  // Function to load more blog posts
  function loadMoreBlogPosts() {
    if (isLoading || currentPage >= maxPages || allPostsLoaded) return;

    isLoading = true;
    if (loadingIndicator) loadingIndicator.style.display = "block";

    // Prepare AJAX request
    const formData = new FormData();
    formData.append("action", "load_more_posts");
    formData.append("page", currentPage + 1);
    formData.append("nonce", ajaxCNC.nonce);

    fetch(ajaxCNC.ajax_url, {
      method: "POST",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.success && data.data.posts && data.data.posts.trim() !== "") {
          // Append new posts to container
          blogPostsContainer.insertAdjacentHTML("beforeend", data.data.posts);
          currentPage = data.data.current_page;

          // Hide loading indicator if we've reached max pages
          if (currentPage >= data.data.max_pages) {
            allPostsLoaded = true;
            if (loadingIndicator) {
              loadingIndicator.innerHTML =
                '<p class="completion-message">All posts have been loaded. Thank you for reading.</p>';
              loadingIndicator.style.display = "block";
            }
          } else {
            if (loadingIndicator) loadingIndicator.style.display = "none";
          }
        } else {
          // No posts returned or error occurred
          allPostsLoaded = true;
          if (loadingIndicator) {
            loadingIndicator.innerHTML =
              '<p class="completion-message">All posts have been loaded. Thank you for reading.</p>';
            loadingIndicator.style.display = "block";
          }
          console.error("Error loading posts:", data);
        }
      })
      .catch((error) => {
        console.error("AJAX error:", error);
        allPostsLoaded = true;
        if (loadingIndicator) {
          loadingIndicator.innerHTML =
            '<p class="completion-message">Error loading posts. Please refresh the page.</p>';
          loadingIndicator.style.display = "block";
        }
      })
      .finally(() => {
        isLoading = false;
      });
  }

  // Throttle scroll event for performance
  let ticking = false;
  function handleScroll() {
    if (!ticking) {
      requestAnimationFrame(() => {
        const scrollTop =
          window.pageYOffset || document.documentElement.scrollTop;
        const windowHeight = window.innerHeight;
        const documentHeight = document.documentElement.scrollHeight;

        // Load more posts when user scrolls to 80% of the page
        if (
          scrollTop + windowHeight >= documentHeight * 0.8 &&
          !allPostsLoaded
        ) {
          loadMoreBlogPosts();
        }

        ticking = false;
      });
      ticking = true;
    }
  }

  // Add scroll event listener
  window.addEventListener("scroll", handleScroll);

  // Fallback: Load more button click event (if visible)
  const loadMoreButton = document.getElementById("load-more-posts");
  if (loadMoreButton) {
    loadMoreButton.addEventListener("click", function () {
      loadMoreBlogPosts();
    });
  }
});

// document.addEventListener('DOMContentLoaded', function () {

//   const hero = document.querySelector('.hero-banner');
//   if (!hero) return;

//   const skeletonHTML = `
//     <div class="skeleton-banner" aria-hidden="true">
//       <div class="container">
//         <div class="skeleton-row">
//           <div class="skeleton-left">
//             <div class="skel title"></div>
//             <div class="skel subtitle"></div>
//             <div style="height:8px;"></div>
//             <div class="skel cta"></div>
//           </div>
//           <div class="skeleton-right" style="min-height:240px;">
//             <div class="skel blob"></div>
//             <div class="skel product"></div>
//             <div class="skel badge"></div>
//           </div>
//         </div>
//       </div>
//     </div>
//   `;


//   const skeletonNode = (new DOMParser()).parseFromString(skeletonHTML, 'text/html').body.firstChild;
//   hero.insertBefore(skeletonNode, hero.firstChild);

//   hero.classList.add('is-loading');

//   const images = Array.from(hero.querySelectorAll('img'));

//   function waitForImage(img) {
//     return new Promise((resolve) => {
//       if (!img) return resolve();
//       if (img.complete && img.naturalWidth !== 0) return resolve();
//       if (img.decode) {
//         img.decode().then(resolve).catch(() => {
//           img.addEventListener('load', resolve, { once: true });
//           img.addEventListener('error', resolve, { once: true });
//         });
//       } else {
//         img.addEventListener('load', resolve, { once: true });
//         img.addEventListener('error', resolve, { once: true });
//       }
//     });
//   }

//   const TIMEOUT = 5000;
//   const timeoutId = setTimeout(() => {
//     finishLoading();
//   }, TIMEOUT);

//   Promise.all(images.map(waitForImage)).then(finishLoading);

//   function finishLoading() {
//     clearTimeout(timeoutId);
//     setTimeout(() => {
//       hero.classList.remove('is-loading');
//       hero.classList.add('loaded');
//       if (skeletonNode && skeletonNode.parentNode) {
//         skeletonNode.remove();
//       }
//     }, 10000);
//   }
// });


document.addEventListener('DOMContentLoaded', function () {
  const hero = document.querySelector('.hero-banner');
  if (!hero) return;

  const skeletonHTML = `
    <div class="skeleton-banner" aria-hidden="true">
      <div class="container">
        <div class="skeleton-row">
          <div class="skeleton-left">
            <div class="skel title"></div>
            <div class="skel subtitle"></div>
            <div style="height:8px;"></div>
            <div class="skel cta"></div>
          </div>
          <div class="skeleton-right" style="min-height:240px;">
            <div class="skel blob"></div>
            <div class="skel product"></div>
            <div class="skel badge"></div>
          </div>
          <div class="skeleton-left-mobile">
            <div class="skel title"></div>
            <div class="skel subtitle"></div>
            <div style="height:8px;"></div>
            <div class="skel cta"></div>
          </div>
        </div>
      </div>
    </div>
  `;

  const skeletonNode = (new DOMParser()).parseFromString(skeletonHTML, 'text/html').body.firstChild;
  hero.insertBefore(skeletonNode, hero.firstChild);

  hero.classList.add('is-loading');

  const images = Array.from(hero.querySelectorAll('img'));

  function waitForImage(img) {
    return new Promise((resolve) => {
      if (!img) return resolve();
      if (img.complete && img.naturalWidth !== 0) return resolve();
      if (img.decode) {
        img.decode().then(resolve).catch(() => {
          img.addEventListener('load', resolve, { once: true });
          img.addEventListener('error', resolve, { once: true });
        });
      } else {
        img.addEventListener('load', resolve, { once: true });
        img.addEventListener('error', resolve, { once: true });
      }
    });
  }

  const TIMEOUT = 5000;
  const timeoutId = setTimeout(() => {
    finishLoading();
  }, TIMEOUT);

  Promise.all(images.map(waitForImage)).then(finishLoading);

  function finishLoading() {
    clearTimeout(timeoutId);
    setTimeout(() => {
      hero.classList.remove('is-loading');
      hero.classList.add('loaded');
      if (skeletonNode && skeletonNode.parentNode) {
        skeletonNode.remove();
      }
    }, 200);
  }
});
